import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { adminService } from "@/services/adminService";
import { brandService } from "@/services/brandService";
import { errorMessage } from "@/services/apiClient";

const control = "h-10 rounded-md border border-[#22252F] bg-[#12141A] px-3 text-sm text-white";

export const ExportClientsButton = () => {
  const [brands, setBrands] = useState([]);
  const [brand, setBrand] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    brandService.list().then(setBrands).catch(() => setBrands([]));
  }, []);

  const download = async () => {
    setBusy(true);
    try {
      const res = await adminService.exportClients(brand);
      const name = (res.headers["content-disposition"] || "").match(/filename="?([^"]+)"?/)?.[1]
        || "clientes.xlsx";
      const url = URL.createObjectURL(res.data);
      const link = document.createElement("a");
      link.href = url;
      link.download = name;
      link.click();
      URL.revokeObjectURL(url);
      toast.success("Excel gerado");
    } catch (e) {
      toast.error(errorMessage(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex items-center gap-2" data-testid="export-clients">
      <select data-testid="export-brand-select" value={brand} onChange={(e) => setBrand(e.target.value)}
              className={control}>
        <option value="">Todo o site</option>
        <option value="none">Sem Brand (Meridian)</option>
        {brands.map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
      </select>
      <button data-testid="export-clients-button" onClick={download} disabled={busy}
              className="inline-flex h-10 items-center gap-2 rounded-md bg-[#10B981] px-4 text-sm font-semibold text-[#04150F] hover:bg-[#0EA271] disabled:opacity-60">
        <Download className="h-4 w-4" /> {busy ? "A gerar..." : "Excel"}
      </button>
    </div>
  );
};
